import React from "react";

import {
  Box,
  Divider,
  List,
  styled,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  backToPrevState,
  keepOpenDrawer,
  toggleDrawer,
} from "../../store/drawer.slice";
import { drawerWidth } from "./Header";

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: 0,
  [theme.breakpoints.up("sm")]: {
    width: 0,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function SideBar() {
  // useEffect(() => {
  //   dispatch(menuActions.get());
  // }, []);
  const isMobile = useMediaQuery("(max-width:769px)");
  const auth = useAppSelector((state) => state.auth);
  React.useEffect(() => {
    if (isMobile) {
      dispatch(toggleDrawer());
    }

    if (!isMobile && !open) {
      dispatch(toggleDrawer());
    }
  }, [isMobile]);
  const open = useAppSelector((state) => state.drawer.open);
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const onSelect = (event) => {
    navigate(event.target.props.route);
  };
  const path = location.pathname
    .split("/")
    .filter((d) => d === "" || isNaN(d))
    .join("/");

  return (
    <Drawer
      variant="permanent"
      open={open}
      onMouseEnter={() => dispatch(keepOpenDrawer())}
      onMouseLeave={() => dispatch(backToPrevState())}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: "0px!important",
          ...(!open && {
            visibility: "hidden",
            transition: theme.transitions.create(["visibility"], {
              easing: theme.transitions.easing.easeInOut,
              duration: theme.transitions.duration.standard,
            }),
          }),
        }}
      >
        <a className="nav-link" href={"/"}>
          <img
            id="idLogo"
            src="https://www.daikin.com.tr/Content/img/icons/daikin-logo.svg"
            alt=""
          ></img>
        </a>
      </Toolbar>
      <Divider />
      <List component="nav">
        <Box
          className="info"
          sx={{
            ml: 2,
            my: 1,
            ...(!open && {
              visibility: "hidden",
              transition: theme.transitions.create(["visibility"], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard,
              }),
            }),
          }}
        >
          <span style={{ fontStyle: "italic" }}>
            {t("welcome")}, <b>{auth.user?.given_name}</b>
          </span>
        </Box>
        <Divider variant="fullWidth" />

        <PanelBar expandMode={"single"} onSelect={onSelect}>
          <PanelBarItem
            iconClass="fa fa-calendar fa-5"
            title={
              <>
                <Link className="nav-link" state={{ from: location }}>
                  {"Başvurular"}
                </Link>
              </>
            }
            selected={"/list" === path}
            route={"/list"}
          />

          {/*           
          <PanelBarItem title={t("events")}>
            {dynamicPanelBarItems}
          </PanelBarItem> */}
        </PanelBar>
      </List>
    </Drawer>
  );
}
